import React, { useEffect, useState } from "react";
import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";

import L from "leaflet";

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export interface MapComponentProps {
  center?: number[];
  zoom?: number; 
  scrollWheelZoom?: false;
  style?: React.CSSProperties;
  pinList?: { position: number[]; name: string }[];
}

const MapComponent = ({ pinList, style, center }: MapComponentProps) => {
  const [pointsOfInterest, setPointsOfInterest] = useState([{position: [0,0], name: "aucune location"}]);


  useEffect(() => {
    if (pinList)
    setPointsOfInterest(pinList);
  }, [pinList]);


  return (
    <>
      <MapContainer
        center={center as any}
        zoom={13}
      
        style={style}

      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {pointsOfInterest &&
          pointsOfInterest.map((point, index) => (
            <Marker key={index} position={point.position as any}>
              <Popup>{point.name}</Popup>
            </Marker>
          ))}
      </MapContainer>
    </>
  );
};

export default MapComponent;
